module.exports = __webpack_public_path__ + "static/media/stat547u_lecture03.53e954a6.pdf";